export default "/profile/images/wayforpay.png?f2a0a3cc79b51cb8d4b64f1f33932de6";